export var SelectionModeOptions;
(function (SelectionModeOptions) {
    SelectionModeOptions[SelectionModeOptions["None"] = 1] = "None";
    SelectionModeOptions[SelectionModeOptions["MostMealQuantity"] = 2] = "MostMealQuantity";
})(SelectionModeOptions || (SelectionModeOptions = {}));
export var MealSizeText;
(function (MealSizeText) {
    MealSizeText["MEAL_SIZE_CHANGE_WARNING"] = "{meal_entity_name} Size Change Warning";
    MealSizeText["DEFAULT_WARNING_TEXT"] = "Changing this will remove all your {meal_entity_name_plural} and recipes from the cart.";
    MealSizeText["CONFIRM"] = "Confirm";
    MealSizeText["CANCEL"] = "Cancel";
    MealSizeText["NO_MEAL_SIZES_TO_DISPLAY"] = "No {meal_entity_name} sizes to display.";
})(MealSizeText || (MealSizeText = {}));
